<div class="progress" [style.width.%]="progress"></div>
